import { message } from "antd";
import axios from "axios";

// export const APP_BASE_URL = "https://ems-nsdluat.paycraftsol.in:7443"; // UAT
export const APP_BASE_URL = "https://emsweb.paycraftsol.com"; // PROD

const publicUrls = [
  "/admin/v1/login",
  "/api/admin/auth/v1/getToken",
  "/api/otps/v1/verify",
  "/api/auth/v1/login",
  "/api/staff/v1/login",
  "/api/staff/v1/resetPassword",
  "/api/staff/v1/forgotPassword",
  "/api/user/v1/resetPassword",
  "/api/user/v1/forgotPassword",
  "/api/otps/v1/resend",
  "/api/v1/inquiry",
  "/api/v1/health-check",
  "/api/cards/v1/paymentGatewayRedirect",
  "/api/cards/v1/pinset",
  "/api/cards/v1/vcip-success",
  "/api/admin/cards/v1/import",
  "/api/cards/v1/import",
  "/api/download/v1/file",
  "/api/v1/send-reset-mails",
  "/api/v1/set-employee-approvals",
];

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const endpoint = axios.create({
  baseURL: APP_BASE_URL,
});

endpoint.interceptors.request.use(
  function (config) {
    const reqUrl = config.url || "";

    const skipAuth = publicUrls.some((u) => reqUrl === u);

    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }

    if (!skipAuth && sessionStorage.getItem("token")) {
      config.headers.Authorization =
        "Bearer " + sessionStorage.getItem("token");
    }

    config.headers.deviceType = "web";

    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

endpoint.interceptors.response.use(
  function (response) {
    if (
      response?.data?.message &&
      !response.config?.skipSuccessMessage &&
      response.data.status === true &&
      response.data.message !== "Refresh Token Successful"
    ) {
      message.success(
        <span className="messageText">{response.data.message}</span>,
      );
    }
    return response;
  },
  function (error) {
    const status = error?.response?.status;
    const messageText =
      error?.response?.data?.message || error?.response?.data?.errors || "";
    if (
      status === 422 ||
      messageText.toLowerCase().includes("session expired") ||
      messageText.includes("MISSING_AUTHENTICATION") ||
      messageText.toLowerCase().includes("signature has expired")
    ) {
      source.cancel("Session Timeout");
      message.error(
        <span className="messageText">
          Session Expired. Please login again.
        </span>,
      );
      sessionStorage.clear();
      window.location.href = "/";
      return Promise.reject(error);
    }
    if (error.config?.skipErrorMessage) {
      return Promise.reject(error);
    }
    const errorMsg =
      error?.response?.data?.message ||
      error?.response?.data?.errors ||
      error?.message;

    if (
      error?.response?.data?.status !== true &&
      errorMsg &&
      String(errorMsg).trim()
    ) {
      message.error(
        <span className="messageText">{errorMsg}</span>
      );
    }

    return Promise.reject(error);
  },
);

export default endpoint;
